import React, { useState, useEffect } from "react";
import { Container  } from "react-bootstrap";
import { easeOut, motion } from "framer-motion";

import "./projects.css";
import ProjectList from "./ProjectList";
import ProjectList2 from "./ProjectList2";

const responsive = {
    desktop: {
      breakpoint: {
        max: 3000,
        min: 1024,
      },
      items: 3,  // Items shown on desktop
      partialVisibilityGutter: 30,
    },
    mobile: {
      breakpoint: {
        max: 550,
        min: 0,
      },
      items: 1,  // Items shown on mobile
      partialVisibilityGutter: 30,
    },
    tablet: {
      breakpoint: {
        max: 1024,
        min: 551,
      },
      items: 2,  // Items shown on tablet
      partialVisibilityGutter: 30,
    },
  };

function MainProject() {
  const [activeTab, setActiveTab] = useState("designProduct");

   const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
    
      useEffect(() => {
        const handleResize = () => {
          setIsSmallScreen(window.innerWidth <= 768);
        };
    
        window.addEventListener('resize', handleResize);
    
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);

  return (
    <Container fluid className="MySkills" id="productcarousel" style={{
      height: isSmallScreen ? "auto" : "100vh",
      marginTop: isSmallScreen ? "2rem" : "10rem"
       }}>

       
      <div >
        
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{
              duration: 0.5,
              delay: 0.3,
              timingFunction: easeOut,
            }}
          >
              {/* Tab buttons */}
              <div className="tabs-contain" style={{marginBottom:"1rem"}}>
              <button
                className={`tab-button ${activeTab === "designProduct" ? "active" : ""}`}
                onClick={() => setActiveTab("designProduct")}
              >
                Design
              </button>
              <button
                className={`tab-button ${activeTab === "developProduct" ? "active" : ""}`}
                onClick={() => setActiveTab("developProduct")}
              >
                Develop
              </button>
            </div><br />
         
            

            
            <br />
          
          </motion.div>
       </div>


        <div style={{marginTop:"0.5rem"}}>
          {/* Tab Content */}
          {activeTab === "designProduct" && <ProjectList responsive={responsive} />}
          {activeTab === "developProduct" && <ProjectList2 responsive={responsive} />}
        
      </div>
    </Container>
  );
}

export default MainProject;
